
import { Link, Route, Routes } from "react-router-dom";

function HomePage() {
  return (
    <main className="app-container">
      <header className="app-header">
        <Link to="/" className="brand">
          Social Platform
        </Link>

        <nav>
          <Link to="/">Home</Link>
          <Link to="/explore">Explore</Link>
          <Link to="/reels">Reels</Link>
          <Link to="/login">Log in</Link>
        </nav>
      </header>

      <section className="hero">
        <p className="eyebrow">A new social experience</p>

        <h1>Connect. Create. Discover.</h1>

        <p>
          Share your ideas, watch videos, build communities
          and experience AI-powered features.
        </p>

        <div className="hero-actions">
          <Link to="/register" className="primary-button">
            Get Started
          </Link>

          <Link to="/explore" className="secondary-button">
            Explore
          </Link>
        </div>
      </section>

      <footer>
        Social Platform — A new way to connect.
      </footer>
    </main>
  );
}

function ComingSoon({ name }: { name: string }) {
  return (
    <main className="coming-soon">
      <h1>{name}</h1>
      <p>This section is under development.</p>
      <Link to="/">Return Home</Link>
    </main>
  );
}

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route
        path="/explore"
        element={<ComingSoon name="Explore" />}
      />
      <Route
        path="/reels"
        element={<ComingSoon name="Reels" />}
      />
      <Route
        path="/login"
        element={<ComingSoon name="Login" />}
      />
      <Route
        path="/register"
        element={<ComingSoon name="Registration" />}
      />
      <Route
        path="*"
        element={<ComingSoon name="Page not found" />}
      />
    </Routes>
  );
}
